import script from "./FPEstimate.vue?vue&type=script&setup=true&lang=js"
export * from "./FPEstimate.vue?vue&type=script&setup=true&lang=js"

import "./FPEstimate.vue?vue&type=style&index=0&id=36779408&lang=scss&scoped=true"
import "./FPEstimate.vue?vue&type=style&index=1&id=36779408&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36779408"]])

export default __exports__